import styled from '@emotion/styled';

export const StyledDiv = styled.div`
  background-color: var(--podium-cds-color-scrim-100);
  bottom: 0;
  display: block;
  left: 0;
  opacity: 0;
  position: fixed;
  right: 0;
  top: 0;
  transition: opacity 250ms, visibility 0s linear 250ms;
  visibility: hidden;
  z-index: 1;

  ${props =>
    props.isOpen &&
    `
      opacity: 1;
      visibility: visible;
      transition: opacity 800ms ease, visibility 0s;
  `};
`;
